import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';

function ProductSmokingHero() {
  return (
    <Container
      component="section"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 9 }}
    >
      <Button
        sx={{
          border: '4px solid currentColor',
          borderRadius: 0,
          height: 'auto',
          py: 2,
          px: 5,
        }}
      >
        <Typography variant="h5" component="span">
        For Catering, Wholesale or General Inquiries
        </Typography>
      </Button>
      <Typography variant="subtitle1" sx={{ my: 3 }}>
       <CallIcon /> (206) 552-0261
      </Typography>
      <Typography variant="subtitle1" sx={{ my: -3 }}>
      <EmailIcon /> info@shanizbakery.com
      </Typography>
     
    </Container>
  );
}

export default ProductSmokingHero;
